/**
 * Join media order for prejoin prefs — aligned with ced-web e254acd.
 * Mic OFF: start muted/speakerOnly audio BEFORE video so peers never see a
 * temporary unmuted state while camera init is still running.
 */

/** @returns {Array<'audio' | 'video'>} */
function getJoinMediaStepOrder({ wantAudio, wantVideo }) {
  const steps = [];
  if (!wantAudio) steps.push('audio');
  if (wantVideo) steps.push('video');
  if (wantAudio) steps.push('audio');
  return steps;
}

/**
 * Start Zoom audio for join. Never startAudio() then muteAudio() — that pulses
 * unmuted and can make same-user peers auto-mute via multi-device exclusivity.
 *
 * @returns {Promise<{ joinedWithAudioOn: boolean, speakerOnly: boolean, failed?: boolean }>}
 */
async function startJoinAudio(stream, { wantAudio }) {
  if (!wantAudio) {
    try {
      await stream.startAudio({ mute: true, speakerOnly: true });
      return { joinedWithAudioOn: false, speakerOnly: true };
    } catch (speakerOnlyErr) {
      console.warn('Could not start speaker-only audio:', speakerOnlyErr);
      try {
        await stream.startAudio({ mute: true });
        return { joinedWithAudioOn: false, speakerOnly: false };
      } catch (muteErr) {
        console.warn('Could not start muted audio:', muteErr);
        return { joinedWithAudioOn: false, speakerOnly: false, failed: true };
      }
    }
  }

  try {
    await stream.startAudio();
    return { joinedWithAudioOn: true, speakerOnly: false };
  } catch (e) {
    console.warn('Could not start audio:', e);
    return { joinedWithAudioOn: false, speakerOnly: false, failed: true };
  }
}

module.exports = {
  getJoinMediaStepOrder,
  startJoinAudio,
};
